import React from 'react';

type Props = {
  isFlashing: boolean;
};

export default function Flash({ isFlashing }: Props) {
  return isFlashing ? (
    <div className="absolute inset-0 bg-white pointer-events-none" style={{ animation: 'captureFlash 180ms ease-out' }} />
  ) : null;
}
